import { Component } from 'react';
import config from './DomainName';
// import { conditionalExpression } from '@babel/types';
// var FormData = require('form-data');

const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ2ZW5kZXIiOnsiaWQiOiI1ZWJkMTMyOTQwMjJhMjNlMmM1YzA4MzkifSwiaWF0IjoxNTkxMTgwOTA3LCJleHAiOjM2MDAwMDAwMDAxNTkxMTgwMDAwfQ.TKBUep0bss3gqQBK8CkbUuRlO3jRLHEvGTGgm90gLRE";


class FetchCall extends Component {


  static getSchoolListDatas = async (id) => {
    let result = await fetch(config.register + 'admin/common/get_drop_down/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };


  static getEnqDetail = async (id) => {
    let result = await fetch(config.register + 'admin/common/enquiry/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };
  
  
  static getCategoryDetail = async (id) => {
    let result = await fetch(config.register + 'admin/common/getcategorydetail/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };
  static getSubCategory = async (id) => {
    let result = await fetch(config.register + 'admin/common/getcategory/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };

  static getNanniesList = async (id) => {
    let result = await fetch(config.register + 'admin/common/get_drop_downs/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };

  static getSchoolDetails = async (id) => {
    let result = await fetch(config.register + 'school/vender/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };

  static getPreSchoolDetails = async (id) => {
    let result = await fetch(config.register + 'preschool/vender/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };
  static getPlayAreaDetails = async (id) => {
    let result = await fetch(config.register + 'playarea/vender/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };



  static grtPartyHallInfo = async (id) => {
    let result = await fetch(config.register + 'partyhall/vender/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };

  static getEventsInfo = async (id, type) => {
    let result = await fetch(config.register + 'admin/events/vender/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };




  static sportsDetails = async (id) => {
    let result = await fetch(config.register + 'sports/vender/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };

  static TutionsInfo = async (id) => {
    let result = await fetch(config.register + 'tution/vender/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };

  static getCreativeActivitiesInfo = async (id) => {
    let result = await fetch(config.register + 'admin/hobbies_intrest/vender/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };
  static getTutionsInfo = async (id) => {
    let result = await fetch(config.register + 'tution/vender/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };

  static getCampInfo = async (id) => {
    let result = await fetch(config.register + 'camps/vender/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };



  static getSummerCampInfo = async (id) => {
    let result = await fetch(config.register + 'summercamps/getsummercampbyvendor/' + id, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };



  static getAdviceInfo = async (id, type) => {
    let result = await fetch(config.register + 'admin/advice/vender/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };


  static getCuratedCampInfo = async (id) => {
    let result = await fetch(config.register + 'curatedcamps/getcampinfo/' + id, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    });
    return result.json();
  };

  static getLeadDetail = async (lead_id) => {

    let result = await fetch(config.register + 'leads/processlead/getDetailLeadAdmin/'+lead_id, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json; charset=UTF-8'
      },
    });
    return result.json();
  }


  static getLeadDetailPartner = async (lead_id, partner_id) => {

    let result = await fetch(config.register + 'leads/processlead/getDetailLeadPartner/'+lead_id+'/'+partner_id, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'x-auth-token': token,
        'Content-Type': 'application/json; charset=UTF-8'
      },
    });
    return result.json();
  }


}


async function addPlayArea(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log(formData);
  let result = await fetch(config.register + 'playarea', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function addDance(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log(formData);
  let result = await fetch(config.register + 'creativeActivity', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}
async function addMusic(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log(formData);
  let result = await fetch(config.register + 'creativeActivity', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}
async function addYoga(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log(formData);
  let result = await fetch(config.register + 'creativeActivity', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}
async function addDrawing(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log(formData);
  let result = await fetch(config.register + 'creativeActivity', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function AddPartyHall(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log(formData);
  let result = await fetch(config.register + 'partyhall', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function AddCakeShop(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log(formData);
  let result = await fetch(config.register + 'cake', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}
async function AddEntertainers(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log(formData);
  let result = await fetch(config.register + 'entatainer', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}
async function AddSuppliers(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log(formData);
  let result = await fetch(config.register + 'admin/events', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function AddVenues(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log(formData);
  let result = await fetch(config.register + 'venue', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function AddCamps(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log(formData);
  let result = await fetch(config.register + 'camps', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function AddSports(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log(formData);
  let result = await fetch(config.register + 'admin/hobbies_intrest', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success', result);
  return result.json();
}
async function AddTutions(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log(formData);
  let result = await fetch(config.register + 'tution', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function createSchool(data) {
  const formData = new FormData();
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  let result = await fetch(config.register + 'admin/schools/add', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}
async function addPreschool(data) {
  const formData = new FormData();
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log(formData);
  let result = await fetch(config.register + 'preschool', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

// changes
async function getSchoolListData(data) {
  const formData = new FormData();
  // for (let key in data) {
  formData.append('keyword', 'timing');
  // }
  console.log(formData);
  let result = await fetch(config.register + 'admin/common/get_drop_down', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: JSON.stringify({
      keyword: 'timing',
    }),
  });
  console.log('Success');
  return result.json();
}

async function AddCounselors(data) {
  const formData = new FormData();
  console.log('school-data', data);
  console.log(data);
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log('school', formData);
  let result = await fetch(config.register + 'admin/advice/add_advice', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}
async function AddNannier(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log('formData', formData);
  let result = await fetch(config.register + 'admin/advice', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success/////');
  return result.json();
}

async function getAdvicelists(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log('formData', formData);
  let result = await fetch(config.register + 'admin/advice/adviceList', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  return result.json();
}

async function preschoolDel(data) {
  let result = await fetch(config.register + 'preschool/deleteId', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function tutionDel(data) {
  let result = await fetch(config.register + 'tution/deleteId', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function eventsDel(data) {
  let result = await fetch(config.register + 'admin/events/deleteId', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function registerVendorNew(data) {

  let result = await fetch(config.register + 'login/register_ins_partner_new', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function registerVendor(data) {

  let result = await fetch(config.register + 'login/register_ins_partner', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function registerPartnerInd(data) {

  let result = await fetch(config.register + 'login/register_partner_ind', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function emailExist(data) {

  let result = await fetch(config.register + 'login/isEmailExist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function emailExist_check(data) {

  let result = await fetch(config.register + 'login/isemailExist_check', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function LoginAdmin(data) {

  let result = await fetch(config.register + 'login/', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function SentOtp(data) {

  let result = await fetch(config.register + 'login/resendOtp', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function checkOTP(data) {

  let result = await fetch(config.register + 'login/checkOtp', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function deleteSchl(data) {

  let result = await fetch(config.register + 'school/deleteScl', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function deactivateUser(data) {
  console.log(data)
  let result = await fetch(config.register + 'admin/common/deactivateUsr', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function getLocation(data) {
  let result = await fetch(config.register + 'admin/common/getLocation', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  console.log('Success');
  return result.json();
}
async function activateUser(data) {
  console.log(data)
  let result = await fetch(config.register + 'admin/common/activateUsr', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function deletePreSchl(data) {

  let result = await fetch(config.register + 'preschool/deleteScl', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function deletePlayArea(data) {

  let result = await fetch(config.register + 'playarea/deleteScl', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function deleteSesCamp(data) {

  let result = await fetch(config.register + 'camps/deleteScl', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function adviceDel(data) {
  let result = await fetch(config.register + 'admin/advice/deleteId', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function deleteHobby(data) {

  let result = await fetch(config.register + 'admin/hobbies_intrest/deleteHob', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function ForgotPass(data) {

  let result = await fetch(config.register + 'admin/common/reset_password', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function ResetPass(data) {

  let result = await fetch(config.register + 'admin/common/update_password', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function changePass(data) {

  let result = await fetch(config.register + 'admin/common/change_password', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function getCatDrop(id) {
  let result = await fetch(config.register + 'admin/common/getCateDrop/' + id, {
    method: 'GET',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
  });
  return result.json();
}


async function getStamps(data) {

  let result = await fetch(config.register + 'stamping/getStamps', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getSchools(data) {

  let result = await fetch(config.register + 'school', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getSchoolsPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/school/schoolpaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function getTuitionsPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/tuition/tuitionpaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getPreSchoolsPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/preschool/preschoolpaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getAFAPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/afa/afapaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getCampsPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/camps/campspaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getCommunityPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/community/communitypaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getEventsPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/events/eventspaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getInsightList(data) {

  let result = await fetch(config.register + 'bewiseapi/insights/insightspaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function getPreSchools(data) {

  let result = await fetch(config.register + 'preschool/getList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getAllPlayareas(data) {

  let result = await fetch(config.register + 'playarea/getList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function getAfterSchools(data) {

  let result = await fetch(config.register + 'admin/hobbies_intrest/getList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function getTutionList(data) {

  let result = await fetch(config.register + 'tution/getList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function getEvents(data) {

  let result = await fetch(config.register + 'admin/events/getList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function getSeasonalCampList(data) {

  let result = await fetch(config.register + 'camps/getList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function getCommunitySupport(data) {

  let result = await fetch(config.register + 'admin/advice/getList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function ImportExcelSchool(data) {
  // const formData = new FormData();
  // console.log(data);
  // for (let key in data) {
  //   formData.append(key, data[key]);
  // }
  // console.log(formData);
  let result = await fetch(config.register + 'import_excel/schools', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function ImportExcelPreSchool(data) {
  // const formData = new FormData();
  // console.log(data);
  // for (let key in data) {
  //   formData.append(key, data[key]);
  // }
  // console.log(formData);
  let result = await fetch(config.register + 'import_excel/preschools', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function ImportExcelPlayarea(data) {
  // const formData = new FormData();
  // console.log(data);
  // for (let key in data) {
  //   formData.append(key, data[key]);
  // }
  // console.log(formData);
  let result = await fetch(config.register + 'import_excel/playareas', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function ImportExcelHobbies(data) {
  // const formData = new FormData();
  // console.log(data);
  // for (let key in data) {
  //   formData.append(key, data[key]);
  // }
  // console.log(formData);
  let result = await fetch(config.register + 'import_excel/hobby_interest', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function ImportExcelTutions(data) {
  // const formData = new FormData();
  // console.log(data);
  // for (let key in data) {
  //   formData.append(key, data[key]);
  // }
  // console.log(formData);
  let result = await fetch(config.register + 'import_excel/tutions', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function ImportExcelEvents(data) {
  // const formData = new FormData();
  // console.log(data);
  // for (let key in data) {
  //   formData.append(key, data[key]);
  // }
  // console.log(formData);
  let result = await fetch(config.register + 'import_excel/events', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function ImportExcelCamp(data) {
  // const formData = new FormData();
  // console.log(data);
  // for (let key in data) {
  //   formData.append(key, data[key]);
  // }
  // console.log(formData);
  let result = await fetch(config.register + 'import_excel/camps', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function ImportExcelCommunity(data) {
  // const formData = new FormData();
  // console.log(data);
  // for (let key in data) {
  //   formData.append(key, data[key]);
  // }
  // console.log(formData);
  let result = await fetch(config.register + 'import_excel/community', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function SubscribeData(data) {
  let result = await fetch(config.register + 'admin/common/getsubscribe', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function ContactData(data) {
  let result = await fetch(config.register + 'admin/common/getcontactus', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function getUserList(data) {
  let result = await fetch(config.register + 'admin/common/getUser', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getVendorList(data) {
  let result = await fetch(config.register + 'admin/common/getVendor', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getLocationList(data) {
  let result = await fetch(config.register + 'admin/common/getLocation', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function getUserInfo(data) {
  let result = await fetch(config.register + 'admin/common/getUserInfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getVendorInfo(data) {
  let result = await fetch(config.register + 'admin/common/getVendorInfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function indResponse(data) {
  let result = await fetch(config.register + 'login/ind_sendresponse', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function indVerifyLink(data) {
  let result = await fetch(config.register + 'login/verifypaymentLink', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function indComSignup(data) {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  let result = await fetch(config.register + 'login/indsignup', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}
async function indUploadDocs(data) {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  let result = await fetch(config.register + 'login/indUploadDocs', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function getMenu(data) {
  let result = await fetch(config.register + 'admin/common/getMenu', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function AddRole(data) {
  let result = await fetch(config.register + 'admin/common/addrole_data', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function getRoles(data) {
  let result = await fetch(config.register + 'admin/common/getRoles', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function getRolelist(data) {
  let result = await fetch(config.register + 'admin/common/getRolelist', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function deleteRole(data) {

  let result = await fetch(config.register + 'admin/common/deleteRole', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function EditRoleData(data) {

  let result = await fetch(config.register + 'admin/common/editRole', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getSubuser(data) {
  let result = await fetch(config.register + 'admin/common/getSubuser', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function deleteUser(data) {

  let result = await fetch(config.register + 'admin/common/deleteUser', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function AddUserData(data) {
  let result = await fetch(config.register + 'admin/common/adduser_data', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function AddExclUserData(data) {
  let result = await fetch(config.register + 'adminuser/addexcluser_data', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function EditSubuserData(data) {

  let result = await fetch(config.register + 'adminuser/editUser', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function editExclUser(data) {

  let result = await fetch(config.register + 'adminuser/editExclUser', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}



async function verifyLogin(data) {
  let result = await fetch(config.register + 'login/verifylogin', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getPlan(data) {
  let result = await fetch(config.register + 'packages/getPlan', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function CreatePay(data) {

  let result = await fetch(config.register + 'admin/common/orders', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function ProfileUpdate(data) {
  const formData = new FormData();
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  let result = await fetch(config.register + 'admin/schools/update_profile', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function getTransactionList(data) {
  let result = await fetch(config.register + 'admin_transaction/getTransaction', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function getInvoiceInfo(data) {
  let result = await fetch(config.register + 'admin_transaction/getInvoice', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getPartnerDetails(data) {
  let result = await fetch(config.register + 'admin/schools/partner', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getCatList(data) {
  let result = await fetch(config.register + 'admin/common/getcategory_list', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function approveVendorInfo(data) {
  let result = await fetch(config.register + 'admin/common/approve_vendor', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function approveVendorInfoCurated(data) {
  let result = await fetch(config.register + 'admin/common/approve_vendor_curated', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function getCommentList(data) {
  let result = await fetch(config.register + 'admin/common/comments_vendor', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getEnquiriesList(data) {
  let result = await fetch(config.register + 'admin/common/enquiries', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getRatingList(data) {
  let result = await fetch(config.register + 'admin/common/rating_vendor', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function rejectVendorInfo(data) {
  let result = await fetch(config.register + 'admin/common/reject_vendor', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function vendorDashboard(data) {
  console.log('**f', JSON.parse(data));
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'admin/dasboard_venodr/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function adminDashboard(data) {
  console.log('**f', JSON.parse(data));
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'admin/dasboard_admin/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getDiscount(data) {
  let result = await fetch(config.register + 'admin/common/getDiscount', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function EditDiscountData(data) {

  let result = await fetch(config.register + 'admin/common/editDis', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function AddDiscount(data) {
  let result = await fetch(config.register + 'admin/common/adddiscount_data', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function getContactServiceList(data) {
  let result = await fetch(config.register + 'admin/dasboard_venodr/service_provider_report', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getDeviceAccess(data) {
  let result = await fetch(config.register + 'admin/dasboard_venodr/device_report', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getWishList(data) {
  let result = await fetch(config.register + 'admin/dasboard_venodr/wishlist_report', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function commonAPI(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'admin/common/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function UpdateVendorPlan(data) {
  let result = await fetch(config.register + 'login/updatevendorplan', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function updategallery(data) {
  console.log('data', data)
  const formData = new FormData();
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  let result = await fetch(config.register + 'admin/partnerapi/updategallery', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function updateVideo(data) {
  console.log('data', data)
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  let result = await fetch(config.register + 'admin/partnerapi/update_video', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function signUpApi(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'admin/signup/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function partnerApi(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'admin/partnerapi/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function partnerDocupload(data) {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  let result = await fetch(config.register + 'admin/partnerapi/updatepDocs', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function partnerBranch(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'partnerbranch/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getAllverticalData(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'admin/partnerapi/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getAllcategoryData(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'admin/partnerapi/fetchcategoryslugs', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function bewiseuserExport(data) {
  let result = await fetch(config.register + 'admin/common/bewiseuserExport', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function userExport(data) {
  let result = await fetch(config.register + 'admin/common/userExport', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function vendorExport(data) {
  let result = await fetch(config.register + 'admin/common/vendorExport', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function contactUserExport(data) {
  let result = await fetch(config.register + 'admin/common/contactUserExport', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function contactPartnerExport(data) {
  let result = await fetch(config.register + 'admin/common/contactPartnerExport', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function transactionExport(data) {
  let result = await fetch(config.register + 'admin/common/transactionExport', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function subExport(data) {
  let result = await fetch(config.register + 'admin/common/subExport', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function CSPExport(data) {
  let result = await fetch(config.register + 'admin/common/CSPExport', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function DAFExport(data) {
  let result = await fetch(config.register + 'admin/common/DAFExport', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function WishExport(data) {
  let result = await fetch(config.register + 'admin/common/WishExport', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function RatingExport(data) {
  let result = await fetch(config.register + 'admin/common/RatingExport', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function getVideoListAdmin(data) {
  let result = await fetch(config.register + 'adminvideo/get_video_list', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getVideoDataAdmin(data) {
  let result = await fetch(config.register + 'adminvideo/edit_video', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function updateAdminVideo(data) {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log('formData', data, formData);
  let result = await fetch(config.register + 'adminvideo/update_video', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function getInsightDetail(data) {
  let result = await fetch(config.register + 'insights/edit_insight', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function getPageDetail(data) {
  let result = await fetch(config.register + 'cms/get_page', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function updatePage(data) {
  let result = await fetch(config.register + 'cms/update_page', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
  

async function approvePage(data) {
  let result = await fetch(config.register + 'cms/approve_page', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getAuthorSuggest(data) {
  let result = await fetch(config.register + 'insights/get_author', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function updateInsights(data) {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log('formData', data, formData);
  let result = await fetch(config.register + 'insights/update_insight', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}
async function uploadArticleImage(data) {
  const formData = new FormData();
  for (let key in data) {
    if (key == 'article_images') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('article_images', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log('formData', data, formData);
  let result = await fetch(config.register + 'insights/uploadarticle_image', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function uploadArticleImages(data) {
  const formData = new FormData();
  for (let key in data) {
    if (key == 'article_images') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('article_images', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log('formData', data, formData);
  let result = await fetch(config.register + 'insights/uploadarticle_images', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function removeInsight(data) {
  let result = await fetch(config.register + 'insights/delete_insight', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function insightApi(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'insights/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function benchApi(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'benchmark/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getPackageList(data) {
  let result = await fetch(config.register + 'packages/get_package_list', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function removePackage(data) {
  let result = await fetch(config.register + 'packages/delete_package', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getPackageDetail(data) {
  let result = await fetch(config.register + 'packages/package_details', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function updatePackageData(data) {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log('formData', data, formData);
  let result = await fetch(config.register + 'packages/update_package', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}
async function getPackageType(data) {
  let result = await fetch(config.register + 'packages/get_package_type_list', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function taxdata(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'tax/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function promodata(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'promo/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function eventResource(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'eventresource/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function updateResource(data) {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log('formData', data, formData);
  let result = await fetch(config.register + 'eventresource/update_resource', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function exportPreschool(data) {
  let result = await fetch(config.register + 'import_excel/exportPreschool', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function exportSchool(data) {
  let result = await fetch(config.register + 'import_excel/exportSchool', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function exportKidsplayArea(data) {
  let result = await fetch(config.register + 'import_excel/exportKidsplayArea', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function exportAfterschool(data) {
  let result = await fetch(config.register + 'import_excel/exportAfterschool', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function exportTuition(data) {
  let result = await fetch(config.register + 'import_excel/exportTuition', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function exportLearningcamps(data) {
  let result = await fetch(config.register + 'import_excel/exportLearningcamps', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function exportCommunitysupport(data) {
  let result = await fetch(config.register + 'import_excel/exportCommunitysupport', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function exportBirthdayEvents(data) {
  let result = await fetch(config.register + 'import_excel/exportBirthdayEvents', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function subPartner(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'subpartner/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function partnerCategory(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'partnercategory/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}





async function partnerMainCategory(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'partnercategory/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function partnerSubCategories(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'partnercategory/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function partnerAfaCategory(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'partnercategory/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function updateRemoveCategory(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'partnercategory/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function adminRoles(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'roles/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function partnerSubscription(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'partnersubscription/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function partnerSubscriptionV1(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'partnersubscription/getcurrentsubscription', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getPartnerSubscriptions(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'partnersubscription/getallsubscription', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function adminExclUser(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'adminuser/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function adminUser(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'adminuser/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function adminPriceChart(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'adminpricechart/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function pNotification(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'pnotification/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function preSclList(data) {
  let result = await fetch(config.register + 'admin/schools/presclList', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getSummerCampList(data) {

  let result = await fetch(config.register + 'summercamps/getAll', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function sclList(data) {
  let result = await fetch(config.register + 'preschool/sclList', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function deleteSummerCamp(data) {

  let result = await fetch(config.register + 'summercamps/deleteSummerCamp', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function adminReport(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'adminreport/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function add_Summer_Camp(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log(formData);
  let result = await fetch(config.register + 'summercamps/add', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}




async function getSearchList(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'admin/common/search', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function getCuratedCampList(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'curatedcamps/getlist', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}



async function getCuratedCampListAll(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'curatedcamps/getlistall', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function add_curated_camp(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log(formData);
  let result = await fetch(config.register + 'curatedcamps/create', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function AddCuratedCamps(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log(formData);
  let result = await fetch(config.register + 'curatedcamps/create', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function UpdateCuratedCamps(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log(formData);
  let result = await fetch(config.register + 'curatedcamps/update', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function UpdateCuratedCampsByAdmin(data) {
  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log(formData);
  let result = await fetch(config.register + 'curatedcamps/updatebyadmin', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function deleteCamp(data) {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log(formData);
  let result = await fetch(config.register + 'curatedcamps/deletecamp', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function ApproveCuratedCamp(data) {

  const formData = new FormData();
  console.log(data);
  for (let key in data) {
    if (key == 'photos') {
      for (let i = 0; i < data[key].length; i++) {
        formData.append('photos', data[key][i]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }
  console.log(formData);
  let result = await fetch(config.register + 'curatedcamps/approve', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();

}

async function DisApproveCuratedCamp(data) {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log(formData);
  let result = await fetch(config.register + 'curatedcamps/disapprovecamp', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function getCuratedPaymentList(camp_id) {

  let result = await fetch(config.register + 'curatedcamps/paymentsbycampid/' + camp_id, {
    method: 'GET',
    mode: 'cors',
    headers: { 'x-auth-token': token }
  });
  console.log('Success');
  return result.json();
}

async function getCuratedRegistrationList(camp_id) {

  let result = await fetch(config.register + 'curatedcamps/registrationbycampid/' + camp_id, {
    method: 'GET',
    mode: 'cors',
    headers: { 'x-auth-token': token }
  });
  console.log('Success');
  return result.json();
}

async function sendWelcomeEmailCamp(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'curatedcamps/sendcopycampinfo', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

/* exclusive partnerships */
async function uploadMedia(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadmedia', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function sclEdit(data) {
  let result = await fetch(config.register + 'admin/schools/editdata', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function uploadLogo(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadlogo', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}
async function sclReject(data) {
  let result = await fetch(config.register + 'admin/schools/reject_data', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function uploadBannerB2b(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadbannerb2b', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function uploadBanner(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadbanner', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function uploadBannerAd(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadbannerad', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function uploadOtherAd(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadotherad', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function uploadBrochure(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadbrochure', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function uploadFile2(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadfile2', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function uploadFile1(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadfile1', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function uploadBrochureNew(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadbrochurenew', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function uploadThumbNew(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadthumbnew', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function uploadThumb2(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadthumb2', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function uploadThumb1(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadthumb1', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function uploadGallery(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadgallery', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function presclEdit(data) {
  let result = await fetch(config.register + 'preschool/editdata', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function uploadImage(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadimage', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function uploadVideo(formData) {

  let result = await fetch(config.register + 'exclusive/common/uploadvideo', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function presclReject(data) {
  let result = await fetch(config.register + 'preschool/reject_data', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
 
  });
  console.log('Success');
  return result.json();
}
 
async function removeExclPtnrsEntry(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/removeentry', {
   method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
} 

async function playareaEdit(data) {
  let result = await fetch(config.register + 'playarea/editdata', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function updateEntry(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/updateentry', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function saveEntry(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/saveentry', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function removalItemBigBanner(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/removebigbanner', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function removalItemExclusiveBanner1(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/removeexclusivebanner1', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function removalItemExclusiveBanner2(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/removeexclusivebanner2', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function playareaReject(data) {
  let result = await fetch(config.register + 'playarea/reject_data', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function submitEntry(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/submitentry', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function submitAdsEntry(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/submitadsentry', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function submitAdsEntryOther(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/submitadsentryother', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function deleteAdEntry(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/delete_ad', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function hobbiesEdit(data) {
  let result = await fetch(config.register + 'admin/hobbies_intrest/editdata', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getExclPtnrsEntry(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/getEntry', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getExclPtnrsEntryB2B(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/getEntryB2b', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function hobbiesReject(data) {
  let result = await fetch(config.register + 'admin/hobbies_intrest/reject_data', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
 
  return result.json();
}

async function getExclPtnrsEntryById(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/getEntryById', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function tuitionEdit(data) {
  let result = await fetch(config.register + 'tution/editdata', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });

  return result.json();
}


async function getExclusiveList() {

  let result = await fetch(config.register + 'exclusive/common/getListAdmin', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}

async function tuitionReject(data) {
  let result = await fetch(config.register + 'tution/reject_data', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function deleteExclPartnership(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/removeentry', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function communityEdit(data) {
  let result = await fetch(config.register + 'admin/advice/editdata', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getUnseenEntries() {

  let result = await fetch(config.register + 'exclusive/common/getUnSeenEntries', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    }
  });
  return result.json();
}

async function communityReject(data) {
  let result = await fetch(config.register + 'admin/advice/reject_data', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function sendAdminMessage(data) {

  let result = await fetch(config.register + 'exclusive/common/sendamessage', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function learningEdit(data) {
  let result = await fetch(config.register + 'camps/editdata', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function changeStatusExclPart(data) {

  let result = await fetch(config.register + 'exclusive/common/changestatus', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function learningReject(data) {
  let result = await fetch(config.register + 'camps/reject_data', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function makeMessageRead(data) {

  let result = await fetch(config.register + 'exclusive/common/makeamessageread', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function eventEdit(data) {
  let result = await fetch(config.register + 'admin/events/editdata', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function eventReject(data) {
  let result = await fetch(config.register + 'admin/events/reject_data', {

    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function retailerAPI(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'retailer/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function retailerUpdate(data) {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  let result = await fetch(config.register + 'retailer/retailer_update', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function importRetailer(data) {
  let result = await fetch(config.register + 'retailer/import', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function updateSplEvent(data) {
  let result = await fetch(config.register + 'event_module/event_update', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function splEvent(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'event_module/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

/* end exclpartnerships */
 

async function packageAPI(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'packages/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function partnerReportV1(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'partner_reportV1/' + t.url, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getLeadsByPartner(data) {

  let result = await fetch(config.register + 'leads/processlead/getLeadsByPartner', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function ParterSeenLead(data) {

  let result = await fetch(config.register + 'leads/processlead/saveseen', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function checkPaidOrNot(data) {

  let result = await fetch(config.register + 'leads/processlead/checkpaidpartners', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function updateLeadAction(data) {

  let result = await fetch(config.register + 'leads/processlead/updateleadaction', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getPartnerLeadNew(data) {

  let result = await fetch(config.register + 'leads/processlead/getunseenleads', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getPartnerLeadInfo(data) {

  let result = await fetch(config.register + 'leads/processlead/getpartnersleadinfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getPartnerAds() {

  let result = await fetch(config.register + 'leads/processlead/getPartnerads', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}

async function getAllAds() {

  let result = await fetch(config.register + 'leads/processlead/getAllads', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}

async function getOtherAds() {

  let result = await fetch(config.register + 'leads/processlead/getOtherads', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}

async function getSEOContents() {

  let result = await fetch(config.register + 'cms/vertical/getlist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}

async function deleteContent(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'cms/vertical/delete', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getSuggest(data) {
  let result = await fetch(config.register + 'leads/processlead/get_suggest', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function updatePremiumList(data) {
  let result = await fetch(config.register + 'leads/processlead/savepremiumentry', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function exclprtshipsListPartners(data) {
  let result = await fetch(config.register + 'exclusive/common/get_list_front_partners', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function exclprtshipsList(data) {
  let result = await fetch(config.register + 'exclusive/common/get_list_front', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function getPremiumList(data) {
  let result = await fetch(config.register + 'leads/processlead/getpremiumlist', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function removeTopFiveEntry(data) {
  let result = await fetch(config.register + 'leads/processlead/removepremiumlist', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function removelead(data) {
  let result = await fetch(config.register + 'leads/processlead/removelead', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function stampSchool(data) {
  let result = await fetch(config.register + 'leads/processlead/stampunstamp', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function checkifEligibleForStamping(data) {
  let result = await fetch(config.register + 'leads/processlead/checkifvendorexist', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function checkiffeatured(data) {
  let result = await fetch(config.register + 'featured/act/checkiffeatured', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function checkDiscountInfo(data) {
  let result = await fetch(config.register + 'discount/act/checkdiscountexist', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function discount_update(data) {
  let result = await fetch(config.register + 'discount/act/discount_update', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function creatediscount(data) {
  let result = await fetch(config.register + 'discount/act/create', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function removediscount(data) {
  let result = await fetch(config.register + 'discount/act/remove', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function moveup_update(data) {
  let result = await fetch(config.register + 'featured/act/moveup_update', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function moveup(data) {
  let result = await fetch(config.register + 'featured/act/moveup', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function removefeatured(data) {
  let result = await fetch(config.register + 'featured/act/remove', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function confirmLead(data) {
  let result = await fetch(config.register + 'leads/processlead/checkpushLeadV1', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function checkpushLead(data) {
  let result = await fetch(config.register + 'leads/processlead/checkpushLeadV1', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function createLead(data) {
  let result = await fetch(config.register + 'leads/processlead/createlead', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function getLead_Stats(data) {

  let result = await fetch(config.register + 'leads/processlead/getleads_stat', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getMailInfo(data) {

  let result = await fetch(config.register + 'leads/processlead/getmailinfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getPayLink(data) {

  let result = await fetch(config.register + 'razorpay/common/generatelink', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function sendMailPayLink(data) {

  let result = await fetch(config.register + 'razorpay/common/sendlinktomail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getDiscountNew(data) {

  let result = await fetch(config.register + 'razorpay/common/getDiscountNew', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getPaymentLinkInfo(data) {

  let result = await fetch(config.register + 'razorpay/common/getPaymentLinkInfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function updatePaymentInfo(data) {

  let result = await fetch(config.register + 'razorpay/common/updatePaymentInfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getRazorPayTransactionList(data) {
  let result = await fetch(config.register + 'razorpay/common/getRazorPayTransactionList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}




async function getPaymentLinkInfoDetail(data) {
  let result = await fetch(config.register + 'razorpay/common/getRazorPayDetail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function partnerSubscriptionAfterRazorPayLinks(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'razorpay/common/' + (t.url), {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getVerticalUserCount(data) {
  let result = await fetch(config.register + 'razorpay/common/getVerticalUserCount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function getSchoolNoOfRegistered(data) {
  let result = await fetch(config.register + 'bewiseapi/school/noofregistered', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getSchoolNoOfUnRegistered(data) {
  let result = await fetch(config.register + 'bewiseapi/school/noofunregistered', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function getMailList(data) {
  let result = await fetch(config.register + 'bewiseapi/cms/mails', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getCMSSiteList(data) {
  let result = await fetch(config.register + 'bewiseapi/cms/sitecontent', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function getImagesList(data) {
  let result = await fetch(config.register + 'bewiseapi/general/imagelist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}
async function getMail(data) {
  let result = await fetch(config.register + 'bewiseapi/cms/mail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getSchoolDetail(data) {
  let result = await fetch(config.register + 'bewiseapi/school/editdata', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}




async function uploadEditorImage(formData) {

  let result = await fetch(config.register + 'campaign/mail/uploadeditorimage', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}

async function getAreaNamesListV2() {

  let result = await fetch(config.register + 'bewiseapi/general/getAreaList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}

async function getCityList() {

  let result = await fetch(config.register + 'bewiseapi/general/getCityList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}

async function getContacts() {

  let result = await fetch(config.register + 'bewiseapi/general/getContacts', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}

async function saveCity(formData) {

  let result = await fetch(config.register + 'bewiseapi/general/saveCity', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: formData
  });
  return result.json();
}


async function getRoleListV1(data) {
  let result = await fetch(config.register + 'bewiseapi/admin/getRolelist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getRoleMenus(data) {
  let result = await fetch(config.register + 'bewiseapi/admin/getAdminRoleMenu', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function saveRole(data) {
  let result = await fetch(config.register + 'bewiseapi/admin/saverole', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getGST(data) {
  let result = await fetch(config.register + 'bewiseapi/admin/getGST', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function saveGST(data) {
  let result = await fetch(config.register + 'bewiseapi/admin/saveGST', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getPlanList(data) {
  let result = await fetch(config.register + 'bewiseapi/admin/get_package_list', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getRazorPayTransactionListV1(data) {
  let result = await fetch(config.register + 'bewiseapi/payments/getRazorPayTransactionList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getTransactionListV1(data) {
  let result = await fetch(config.register + 'bewiseapi/payments/getTransactionList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function saveSiteContent(data) {
  let result = await fetch(config.register + 'bewiseapi/cms/saveSiteContent', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function removeCMSSiteContent(data) {
  let result = await fetch(config.register + 'bewiseapi/cms/removeSiteContent', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function saveMail(data) {
  let result = await fetch(config.register + 'bewiseapi/cms/saveMail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function getParentsPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/users/parentpaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function getExclusivePartnersPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/users/exclusivepartnerspaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getPartnerPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/users/partnerspaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getPartnerPagedTrashed(data) {

  let result = await fetch(config.register + 'bewiseapi/users/partnerspagedtrashed', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getBewiseUsersPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/users/bewiseuserspaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getPromoCodeList(data) {
  let result = await fetch(config.register + 'bewiseapi/admin/getPromoCodes', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getResourceList(data) {
  let result = await fetch(config.register + 'bewiseapi/admin/get_resource_list', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getBeWiseCuratedCampList(data) {
  let result = await fetch(config.register + 'bewiseapi/admin/get_bewise_curated_camps', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getNewsList(data) {
  let result = await fetch(config.register + 'bewiseapi/cms/get_news', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function getSpecialPageList(data) {
  let result = await fetch(config.register + 'bewiseapi/cms/get_pages', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getNews(data) {
  let result = await fetch(config.register + 'bewiseapi/cms/get_news_single', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function saveNews(data) {
  let result = await fetch(config.register + 'bewiseapi/cms/saveNews', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getArticleDetail(data) {
  let result = await fetch(config.register + 'bewiseapi/insights/getBlogDetail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getWebsiteAds() {

  let result = await fetch(config.register + 'bewiseapi/cms/getOtherads', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}

async function getRoleDetail(data) {
  let result = await fetch(config.register + 'bewiseapi/admin/getRoleDetail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getMailCampaignList(data) {
  let result = await fetch(config.register + 'campaign/mail/getlist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function uploadEmailImage(formData) {

  let result = await fetch(config.register + 'campaign/mail/uploadimage', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function saveEmailCampaign(data) {

  let result = await fetch(config.register + 'campaign/mail/savecampaign', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function updateEmailCampaign(data) {

  let result = await fetch(config.register + 'campaign/mail/updatecampaign', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function startEmailCampaign(data) {

  let result = await fetch(config.register + 'campaign/mail/savestartcampaign', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getEmailCampaign(data) {
  let result = await fetch(config.register + 'campaign/mail/getDetail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function getCampaignMailInfo(data) {

  let result = await fetch(config.register + 'campaign/mail/getmailinfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function cancelCampaign(data) {

  let result = await fetch(config.register + 'campaign/mail/canceljob', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function savePayLink(data) {

  let result = await fetch(config.register + 'razorpay/common/savegeneratedlink', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function cancelRemoveCampaign(data) {

  let result = await fetch(config.register + 'campaign/mail/cancelremovejob', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getCampaignBatches(data) {

  let result = await fetch(config.register + 'campaign/mail/getCampaignBatch', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getAllUnpaidUsers(data) {

  let result = await fetch(config.register + 'campaign/mail/getAllUnpaidUsers', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function updateOpt(data) {

  let result = await fetch(config.register + 'campaign/mail/updateOpt', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getJobs(data) {

  let result = await fetch(config.register + 'campaign/mail/getJobs', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function getIncompleteLeads() {

  let result = await fetch(config.register + 'leads/processlead/getIncompleteLeads', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}

async function CheckCreatePartner(data) {

  let result = await fetch(config.register + 'razorpay/common/register_partner_by_admin', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getJobsList() {

  let result = await fetch(config.register + 'jobs/getJobsList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}


async function getAreaNamesList() {

  let result = await fetch(config.register + 'admin/common/getAreaList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}


async function saveArea(data) {

  let result = await fetch(config.register + 'admin/common/saveareaname', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function verifyVendor(data) {

  let result = await fetch(config.register + 'login/verifyOTP', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function findpartnersendotplink(data) {

  let result = await fetch(config.register + 'user/auth/sendOTPlink', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function deleteOtherAdEntry(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'exclusive/common/delete_ad_other', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getInsightListPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/insights/insightspaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getInsightListTotal(data) {

  let result = await fetch(config.register + 'bewiseapi/insights/insightstotal', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function getTotalUsers() {

  let result = await fetch(config.register + 'bewiseapi/users/getTotalUsers', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}




async function LoginBeWise(data) {

  let result = await fetch(config.register + 'bewiseapi/login', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getLatestNews() {

  let result = await fetch(config.register + 'bewiseapi/users/getLatestNews', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
  });
  return result.json();
}

async function getCuratedCampListV2(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'curatedcamps/getlistV2', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function partnerArticles(data) {

  let result = await fetch(config.register + 'bewiseapi/insights/getArticlesByPartner', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function beWiseArticles() {

  let result = await fetch(config.register + 'bewiseapi/insights/beWiseArticles', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    }
  });
  
  return result.json();
}

async function schoolCount() {

  let result = await fetch(config.register + 'bewiseapi/school/totalcount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    }
  });
  
  return result.json();
}


async function tuitionCount() {

  let result = await fetch(config.register + 'bewiseapi/tuition/totalcount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    }
  });
  
  return result.json();
}


async function preschoolCount() {

  let result = await fetch(config.register + 'bewiseapi/preschool/totalcount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    }
  });
  
  return result.json();
}


async function afaCount() {

  let result = await fetch(config.register + 'bewiseapi/afa/totalcount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    }
  });
  
  return result.json();
}



async function learningcampCount() {

  let result = await fetch(config.register + 'bewiseapi/camps/totalcount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    }
  });
  
  return result.json();
}

async function eventsCount() {

  let result = await fetch(config.register + 'bewiseapi/events/totalcount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    }
  });
  
  return result.json();
}

async function removethisItem(data) {

  let result = await fetch(config.register + 'bewiseapi/general/removethisItem', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function removeExclUser(data) {

  let result = await fetch(config.register + 'bewiseapi/general/removeexclusiveuser', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function movetoTrash(data) {

  let result = await fetch(config.register + 'bewiseapi/general/movetotrash', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function activatePartner(data) {

  let result = await fetch(config.register + 'bewiseapi/general/activatepartner', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function deActivatePartner(data) {

  let result = await fetch(config.register + 'bewiseapi/general/deactivatepartner', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function getTotal(data) {

  let result = await fetch(config.register + 'bewiseapi/general/getTotal', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getTotalPartners(data) {

  let result = await fetch(config.register + 'bewiseapi/users/partnertotal', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getTotalPartnersTrashed(data) {

  let result = await fetch(config.register + 'bewiseapi/users/partnertotaltrashed', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getTotalParents(data) {

  let result = await fetch(config.register + 'bewiseapi/users/parentstotal', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getTotalBewiseUsers(data) {

  let result = await fetch(config.register + 'bewiseapi/users/bewiseuserstotal', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getTotalTransactions(data) {

  let result = await fetch(config.register + 'bewiseapi/payments/gettotaltransactions', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getLeads(data) {

  let result = await fetch(config.register + 'leads/processlead/getLeadsAdmin', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getTotalLeads(data) {

  let result = await fetch(config.register + 'leads/processlead/getTotalLeads', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function findTeachers(data) {

  let result = await fetch(config.register + 'bewiseapi/wiseconnect/find', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function checkifduplicateExist(data) {

  let result = await fetch(config.register + 'bewiseapi/general/checkifduplicateExist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function checkDuplicateUrl(data) {

  let result = await fetch(config.register + 'bewiseapi/general/checkDuplicateUrl', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getTotalSubscribers(data) {

  let result = await fetch(config.register + 'bewiseapi/wiseconnect/getTotalSubscribers', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function getSubscribersListPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/wiseconnect/getsubscriberspaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function getTotalRegistered(data) {

  let result = await fetch(config.register + 'bewiseapi/wiseconnect/getTotalRegistered', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}



async function getRegisteredListPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/wiseconnect/getregisteredpaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getTotalNewsLetterSubscribers(data) {

  let result = await fetch(config.register + 'bewiseapi/wiseconnect/getTotalNewsLetterSubscribers', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getNewsLetterSubscribersListPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/wiseconnect/getnewslettersubscriberspaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function exportWcSubscribers(data) {
  let result = await fetch(config.register + 'import_excel/exportWcSubscribers', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function getKidsPlayAreaPaged(data) {

  let result = await fetch(config.register + 'bewiseapi/kidsplayarea/kidsplayareapaged', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function createLeadManual(data) {
  let result = await fetch(config.register + 'leads/processlead/createLeadManual', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function getDuplicatesPaged(data) {
  let result = await fetch(config.register + 'bewiseapi/general/findduplicates', {
    method: 'post',
    mode: 'cors',
    'x-auth-token': token,
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function getTotalDuplicates(data) {

  let result = await fetch(config.register + 'bewiseapi/general/getTotalDuplicates', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
} 

async function restoreTrash(data) {

  let result = await fetch(config.register + 'bewiseapi/general/restoretrash', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function approveBulk(data) {

  let result = await fetch(config.register + 'bewiseapi/general/approveBulk', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function approveInsight(data) {

  let result = await fetch(config.register + 'insights/approveInsight', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function postajob(data) {

  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log('formData', data, formData);
  let result = await fetch(config.register + 'wc/postajob', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();

}


async function getjobs(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/getjobsbyins', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function getJobDetailTeacher(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/getjobdetail_teacher', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function getProfileDetail(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/getProfileData', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function getEducations(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/geteducations', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function getExperiences(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/getexperiences', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function getJobDetail(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/getjobdetail', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function getApplicants(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/getApplicants', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function updatejob(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/updatejob', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function getTotalApplicants(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/gettotalapplicants', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function saveJobStatus(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/savejobstatus', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function getTalents(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/gettalent', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function getOtherCoursesListPaged(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/getothercoursespaged', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function getCoursesListPaged(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/getcoursespaged', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function LoginCourse(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/logincourse', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function saveCourse(data) {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log('formData', data, formData);
  let result = await fetch(config.register + 'wc/savecourse', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function getCoursesbyUser(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/getcoursesbyuser', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function getCourseById(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/getcoursebyid', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function updateCourse(data) {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  console.log('formData', data, formData);
  let result = await fetch(config.register + 'wc/updatecourse', {
    method: 'POST',
    mode: 'cors',
    headers: { 'x-auth-token': token },
    body: formData,
  });
  console.log('Success');
  return result.json();
}


async function approvecourse(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/approvecourse', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function createprovider(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/createprovider', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function addjobimporting(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/importjobadd', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}



async function getBlogCategory(data) {

  let result = await fetch(config.register + 'insights/getcategory', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getTotalAuroSubscribers() {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'exclsignups/gettotal', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token }
  
  });
  return result.json();
}

async function getAuroScholarPaged(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'exclsignups/getsignupspaged', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function checkAndsubscribeWiseConnect(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/partnersignup', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function checkifWcSubscribedTrial(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/checkifWcSubscribedTrial', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function getExclPartnerShipDetailById(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'exclusive/common/detail_by_id', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function getJobsListPaged(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/jobspaged', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function getTotalJobs(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/jobstotal', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function getBlogsListPaged(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/blogspaged', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function getTotalBlogs(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/blogstotal', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function postanextblog(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/postablog', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function updateablog(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/updateablog', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function getExtBlogById(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/getextblog', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function processReminderMail(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'exclusive/common/sendingmail', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function sendCustomMail(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'exclusive/common/sendingcustommail', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function generatePdfHtml(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/generatePdfHtml', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}

async function partnerAddBranch(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'wc/partneraddbranch', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getAddonList(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'wc/getAddonList', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getSpecialDiscount(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'wc/getSpecialDiscount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function blockThisUser(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'wc/blockThisUser', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function unBlockThisUser(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'wc/unBlockThisUser', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getCitiesByKeyWord(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/getcitiesbykeyword', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function sendProComFollowUp(data) {
  // let data = JSON.stringify({
  //   keyword: keyword
  // })
  let result = await fetch(config.register + 'wc/sendmailprofilecompletion', {
    method: 'POST',
    'x-auth-token': token,
    mode: 'cors',
    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
    body: data,
  });
  return result.json();
}


async function getEnquiries(data) {

  let result = await fetch(config.register + 'bewiseapi/general/getEnquiries', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getTotalEnquiries(data) {

  let result = await fetch(config.register + 'bewiseapi/general/getTotalEnquiries', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function getPaymentInfo(data) {

  let result = await fetch(config.register + 'razorpay/common/getPaymentInfo', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


async function sendRegretNoData(data) {

  let result = await fetch(config.register + 'bewiseapi/general/sendRegretNoDataMail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function bringNoDateMail(data) {

  let result = await fetch(config.register + 'bewiseapi/general/getBringNoDataMail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}
async function saveExclEnqLead(data) {
  let result = await fetch(config.register + 'wc/saveexclenqlead', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function generateThumbnails() {

  let result = await fetch(config.register + 'wc/generatewebp_blogs', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    }
  });
  console.log('Success');
  return result.json();
}

async function generateDataGraph(data) {

  let result = await fetch(config.register + 'wc/graphs_gen', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function showresultssearch(data) {

  let result = await fetch(config.register + 'wc/showresultssearch', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function checkifLeadsReceived(data) {

  let result = await fetch(config.register + 'wc/checkifleadsreceived', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function resetPasswordSend(data) {

  let result = await fetch(config.register + 'wc/resetpasswordsend', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function saveAbout(data) {

  let result = await fetch(config.register + 'bewiseapi/users/saveAbout', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function leadCharts(data) {

  let result = await fetch(config.register + 'wc/leadcharts', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}

async function leadreportstext(data) {

  let result = await fetch(config.register + 'wc/leadreportstext', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function getcuratedviews(data) {

  let result = await fetch(config.register + 'wc/getcuratedviews', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  console.log('Success');
  return result.json();
}


async function fetch_category_by_ids(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'partnercategory/fetch_category_by_ids', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}

async function getBlobList(data) {
  let t = JSON.parse(data);
  let result = await fetch(config.register + 'az/getcontainerlist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'x-auth-token': token,
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: data,
  });
  return result.json();
}


export {
  getBlobList,
  fetch_category_by_ids,
  activatePartner,
  getcuratedviews,
  leadreportstext,
  leadCharts,
  saveAbout,
  resetPasswordSend,
  checkifLeadsReceived,
  registerVendorNew,
  showresultssearch,
  generateDataGraph,
  generateThumbnails,
  exclprtshipsListPartners,
  saveExclEnqLead,
  uploadBannerB2b,
  bringNoDateMail,
  sendRegretNoData,
  getPageDetail,
  updatePage,
  approvePage,
  getSpecialPageList,
  getPaymentInfo,
  getEnquiries,
  getTotalEnquiries,
  sendProComFollowUp,
  getCitiesByKeyWord,
  //Jul 3
  unBlockThisUser,
  blockThisUser,
  getSpecialDiscount,
  getAddonList,
  partnerAddBranch,
  generatePdfHtml,
  getEducations,
  getExperiences,
  getProfileDetail,
  getTotalRegistered,
  getRegisteredListPaged,
  getTotalNewsLetterSubscribers,
  getNewsLetterSubscribersListPaged,
  sendCustomMail,
  processReminderMail,
  getExtBlogById,
  updateablog,
  postanextblog,
  getBlogsListPaged,
  getTotalBlogs,
  getTotalJobs,
  getJobsListPaged,
  getExclPartnerShipDetailById,
  checkifWcSubscribedTrial,
  checkAndsubscribeWiseConnect,
  getTotalAuroSubscribers,
  getAuroScholarPaged,
  getPartnerSubscriptions,
  partnerSubscriptionV1,
  getBlogCategory,
  getJobDetail,
  addjobimporting,
  createprovider,
  approvecourse,
  updateCourse,
  getCourseById,
  getCoursesbyUser,
  saveCourse,
  LoginCourse,
  getCoursesListPaged,
  getOtherCoursesListPaged,
  getTalents,
  getApplicants,
  saveJobStatus,
  getTotalApplicants,
  postajob,
  getJobDetailTeacher,
  updatejob,
  getjobs,

  //May 29
  approveInsight,
  approveBulk,
  //Apre 12
  getTotalPartnersTrashed,
  getPartnerPagedTrashed,
  movetoTrash,
  restoreTrash,
  deActivatePartner,
  removeExclUser,
  editExclUser,
  checkDuplicateUrl,
  getTotalDuplicates,
  getDuplicatesPaged,
  updateEntry,
  createLeadManual,
  confirmLead,
  getKidsPlayAreaPaged,
  //march 28
  exportWcSubscribers,
  getSubscribersListPaged,
  getTotalSubscribers,
  //march 24
  checkifduplicateExist,
  //Feb 7
  findTeachers,
  getTotalLeads,
  getTotalTransactions,
  getTotalBewiseUsers,
  getTotalParents,
  getEventsPaged,
  getTotalPartners,
  eventsCount,
  getTotal,
  removethisItem,
  schoolCount,preschoolCount, afaCount, learningcampCount,
  tuitionCount,
  beWiseArticles,
  partnerArticles,
  getCuratedCampListV2,
  getLatestNews,
  getTotalUsers,
  getInsightListPaged,
  getInsightListTotal,
  LoginBeWise,
  //Feb 7

  getRoleDetail,
  getWebsiteAds,
  getArticleDetail,
  getNews,
  saveNews,
  getNewsList,
  getBeWiseCuratedCampList,
  getResourceList,
  getPromoCodeList,
  getBewiseUsersPaged,
  getExclusivePartnersPaged,
  getPartnerPaged,
  saveRole,
  getGST,
  saveGST,
  getPlanList,
  getRazorPayTransactionListV1,
  getTransactionListV1,
  saveSiteContent,
  removeCMSSiteContent,
  saveMail,
  getSchools, getPreSchools, getAfterSchools, getTutionList, getEvents, getSeasonalCampList, getCommunitySupport,
  ForgotPass, ResetPass, changePass, SentOtp, checkOTP, getCatDrop, preSclList, sclList,
  adviceDel, deleteSesCamp, deletePlayArea, deleteSchl, LoginAdmin, registerVendor, deleteHobby,
  eventsDel, tutionDel, preschoolDel, getAdvicelists, AddNannier, AddCounselors, getSchoolListData,
  AddSuppliers, AddVenues, AddEntertainers, AddCakeShop, AddCamps, createSchool, AddTutions, AddSports,
  AddPartyHall, addPreschool, addPlayArea, getAllPlayareas, addDance, addDrawing,
  addMusic, addYoga, ImportExcelSchool, ImportExcelPreSchool, ImportExcelPlayarea, ImportExcelHobbies, ImportExcelTutions,
  ImportExcelEvents, ImportExcelCamp, ImportExcelCommunity, SubscribeData, ContactData,
  getUserList, getUserInfo, getLocationList, deletePreSchl, getVendorList, getVendorInfo,
  getMenu, AddRole, getRoles, deleteRole, EditRoleData, getSubuser, deleteUser, AddUserData,
  EditSubuserData, verifyLogin, getPlan, CreatePay, ProfileUpdate, getTransactionList,
  getInvoiceInfo, getPartnerDetails, getCatList, approveVendorInfo, vendorDashboard, adminDashboard,
  emailExist, getCommentList, registerPartnerInd, indResponse, indVerifyLink, indComSignup,
  getEnquiriesList, getRatingList, rejectVendorInfo, getDiscount, EditDiscountData, AddDiscount,
  getContactServiceList, getDeviceAccess, getWishList, commonAPI, UpdateVendorPlan,
  updategallery, signUpApi, partnerApi, bewiseuserExport, userExport, vendorExport, partnerDocupload,
  contactUserExport, contactPartnerExport, transactionExport, subExport, CSPExport, DAFExport, WishExport, RatingExport,
  getVideoListAdmin, getVideoDataAdmin, updateAdminVideo, updateVideo, 
  removeInsight, getInsightDetail, getAuthorSuggest, updateInsights, getPackageList, removePackage,
  getPackageDetail, getPackageType, updatePackageData, emailExist_check, taxdata, promodata, deactivateUser, exportPreschool, exportSchool, exportKidsplayArea,
  exportAfterschool, exportTuition, exportLearningcamps, exportCommunitysupport, exportBirthdayEvents,
  eventResource, updateResource, activateUser, getAllverticalData, getAllcategoryData, subPartner,
  partnerCategory, partnerAfaCategory, partnerSubscription, getLocation, updateRemoveCategory, partnerBranch,
  insightApi, benchApi, adminRoles, adminUser, indUploadDocs, uploadArticleImage, adminPriceChart, pNotification,
  adminReport,
  getSummerCampList,
  deleteSummerCamp,
  add_Summer_Camp,
  getSearchList,
  getCuratedCampList,
  getCuratedCampListAll,
  approveVendorInfoCurated,
  add_curated_camp,
  partnerMainCategory,
  partnerSubCategories,
  AddCuratedCamps,
  UpdateCuratedCamps,
  ApproveCuratedCamp,
  UpdateCuratedCampsByAdmin,
  getCuratedPaymentList,
  getCuratedRegistrationList,
  sendWelcomeEmailCamp,
  uploadMedia,
  uploadLogo,
  uploadBanner,
  uploadBannerAd,
  uploadOtherAd,
  uploadImage,
  uploadVideo,
  saveEntry,
  submitEntry,
  removeExclPtnrsEntry,
  getExclPtnrsEntry,
  getExclPtnrsEntryB2B,
  getExclPtnrsEntryById,
  getExclusiveList,
  deleteExclPartnership,
  getUnseenEntries,
  sendAdminMessage,
  changeStatusExclPart,
  makeMessageRead,
  adminExclUser,
  AddExclUserData,
  sclEdit, 
  presclEdit, 
  playareaEdit, 
  hobbiesEdit, 
  tuitionEdit,
  communityEdit, 
  learningEdit, 
  eventEdit,
  sclReject, 
  presclReject, 
  playareaReject, 
  hobbiesReject, 
  tuitionReject,
  learningReject, 
  communityReject, 
  eventReject, 
  retailerAPI, 
  retailerUpdate, 
  importRetailer,
  updateSplEvent, 
  splEvent, 
  packageAPI, 
  partnerReportV1,
  getLeads,
  getLeadsByPartner,
  ParterSeenLead,
  checkPaidOrNot,
  updateLeadAction,
  getPartnerLeadInfo,
  getPartnerAds,
  getAllAds,
  getOtherAds,
  uploadBrochure,
  exclprtshipsList,
  uploadGallery,
  submitAdsEntry,
  submitAdsEntryOther,
  deleteAdEntry,
  uploadFile1,
  uploadFile2,
  uploadThumb1,
  uploadThumb2,
  getSuggest,
  updatePremiumList,
  getPremiumList,
  removeTopFiveEntry,
  getSEOContents,
  stampSchool,
  getPartnerLeadNew,
  checkifEligibleForStamping,
  getStamps,
  createLead,
  getLead_Stats,
  checkiffeatured,
  checkDiscountInfo,
  moveup,
  creatediscount,
  removefeatured,
  removelead,
  moveup_update,
  getMailInfo,
  getPayLink,
  sendMailPayLink,
  getDiscountNew,
  getPaymentLinkInfo,
  updatePaymentInfo,
  getRazorPayTransactionList,
  getPaymentLinkInfoDetail,
  partnerSubscriptionAfterRazorPayLinks,
  
    //nov 12
  getMailCampaignList,
  uploadEmailImage,
  saveEmailCampaign,
  startEmailCampaign,
  getEmailCampaign,
  updateEmailCampaign,
  getCampaignMailInfo,
  cancelCampaign,
  cancelRemoveCampaign,
  deleteOtherAdEntry,
  getAllUnpaidUsers,
  getCampaignBatches,
  updateOpt,
  getJobs,
  discount_update,
  savePayLink,
  getIncompleteLeads,
  CheckCreatePartner,
  checkpushLead,
  getJobsList,
  getAreaNamesList,
  saveArea,
  verifyVendor,
  findpartnersendotplink,

  getSchoolsPaged,
  getParentsPaged,
  getPreSchoolsPaged,

  getVerticalUserCount,

  getSchoolNoOfRegistered,
  getSchoolNoOfUnRegistered,
  getMailList,
  getMail,
  uploadEditorImage,

  getTuitionsPaged,
  getAFAPaged,
  getCampsPaged,

  getCommunityPaged,
  getInsightList,
  getCMSSiteList,
  getImagesList,
  getSchoolDetail,
  getAreaNamesListV2,
  getCityList,
  getContacts,
  saveCity,
  getRoleListV1,
  getRoleMenus,
  uploadThumbNew,
  uploadBrochureNew,
  removalItemBigBanner,
  removalItemExclusiveBanner1,
  removalItemExclusiveBanner2
};

export default FetchCall;



// WEBPACK FOOTER //
// ./src/API/FetchCall.js